module.exports = __webpack_public_path__ + "static/media/circle1.7487fdbd.svg";